// extracted by mini-css-extract-plugin
export default {"OnboardingProgressContainer":"EmployeeOnboardingProgress_OnboardingProgressContainer__-SFQ8"};